import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import { ServicesSectionProvider } from '../../Context/ServiceSectionContext';
import MainServies from "../../Components/MainServices";
import ScrollColorTransition from "../../Components/ScrollColorTransition/ScrollColorTransition";
import Header from "../../Components/Header";
import Cursor from "../../Components/Cursor";
import ServicesSection from "../../Components/ServicesSection";
import Banner from "../../Components/Banner";
import ColorBG from "../../Components/Overlay";

import 'materialize-css/dist/css/materialize.min.css';
import { Helmet } from "react-helmet";
import { toast } from 'react-toastify';
import ScrollSection from "../../Components/ScrollSection";
// import BubbleEffect from "../../Components/BubbleEffectNew";


const Services = () => {
    const [newNavigate, setNewNavigate] = useState(false)
    const [isNavigate, setIsNavigate] = useState(true)
    const [subServices, setSubServices] = useState([]);
    const [subServicesData, setSubServicesData] = useState([]);
    const location = useLocation();

    const updateNavigate = () => {
        setNewNavigate(!newNavigate)
    }

    const { service } = location.state;
    console.log(service)
    const { id } = useParams()

    const fetchData = () => {
        try {
            setSubServices(service.main_sub_services);
            setSubServicesData(service.main_sub_services[0].sub_services);
        } catch (err) {
            console.error(`Failed to Fetch Services: ${err.message}`, { className: 'red' });
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchData();
        setIsNavigate(!isNavigate);
    }, [id]);

    return (
        <ServicesSectionProvider>
            <Helmet>
                <title>Our Services</title>
                <meta name="description" content="Explore our wide range of services tailored to your needs." />
                <meta name="keywords" content="services, sub services, solutions, main services" />
                <meta name="author" content="Your Company Name" />
            </Helmet>

            <ScrollColorTransition />
            <Cursor />
            <Header />
            
            <div className="overflow-x-hidden">
             
                <MainServies apiData={subServicesData} />
                <ScrollSection />
                <ServicesSection subServices={subServices} update={updateNavigate} id="services-sect" />
                <Banner id="end-sect" />
            </div>
            <ColorBG style={{ top: `${isNavigate || newNavigate ? "0%" : "150%"}`, transform: `${isNavigate || newNavigate ? "rotate(0deg)" : "rotate(10deg)"}`, }} />
        </ServicesSectionProvider>
    );
};

export default Services;

